/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RendicontazioneEsercenteStatus } from './rendicontazione-esercente-status';
import { RendicontazioneNegozioDTO } from './rendicontazione-negozio-dto';


export interface RendicontazioneEsercenteDTO { 
    id?: string;
    periodo_id?: string;
    pratica_esercente_id?: string;
    ragione_sociale?: string;
    partita_iva?: string;
    importo_totale?: number;
    percentuale_rendicontazione?: number;
    status?: RendicontazioneEsercenteStatus;
    ha_nota_esercente?: boolean;
    ha_nota_controfirmata?: boolean;
    version?: number;
    righe?: Array<RendicontazioneNegozioDTO>;
    nota_rifiuto?: string;
}



